var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"score_box"}},[_c('div',[_c('span',{attrs:{"id":"score"}},[_vm._v(_vm._s(_vm.score))])])])}
var staticRenderFns = []

export { render, staticRenderFns }